import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  fmBox_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "4px",
  },
  gray: {
    backgroundColor: theme.colors.gray,
  },
  orange: {
    backgroundColor: theme.colors.orange,
  },
  green: {
    backgroundColor: theme.colors.lightGreen,
  },
  red: {
    backgroundColor: theme.colors.lightRed,
  },
}));

export default useStyles;
